var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{ref:"drawer",attrs:{"width":_vm.width,"right":_vm.borderPosition === 'left',"color":_vm.color,"permanent":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }